import React, { useMemo } from "react";

import {
  FeaturedProductCarousel as UIFeaturedProductCarousel,
  type FeaturedProductCarouselProps as UIFeaturedCarouselProps,
} from "@bared/ui";

import { ProductCardResolver } from "~/lib/ProductCardResolver";
import { ProductBadgeResolver } from "~/lib/ProductBadgeResolver";

import { useSale } from "~/hooks/useSale";
import { useSite } from "~/hooks/useSite";

import type { ProductCardFragment } from "~/types/storefront.generated";

type UISection = UIFeaturedCarouselProps["sections"][number];

export type FeaturedProductCarouselProps = Omit<
  UIFeaturedCarouselProps,
  "sections"
> & {
  sections: (Omit<UISection, "products"> & {
    products: ProductCardFragment[];
  })[];
};

export function FeaturedProductCarousel(props: FeaturedProductCarouselProps) {
  const site = useSite();
  const { isSaleActive } = useSale();

  /**
   * Map products from server data.
   * @todo Move to server when sale context is available there.
   */
  const mappedProps = useMemo(() => {
    const enableSale = isSaleActive();

    return {
      ...props,
      sections: props.sections.map((section) => ({
        ...section,
        products: section.products.map((shopifyProduct) =>
          new ProductCardResolver({
            enableSale,
            shopifyProduct,
            productBadgeResolver: new ProductBadgeResolver({
              enableSale,
              shopifyProduct,
              countryCode: site.countryCode,
            }),
          }).resolve(),
        ),
      })),
    } as UIFeaturedCarouselProps;
  }, [props, isSaleActive]);

  return <UIFeaturedProductCarousel {...mappedProps} />;
}
